import { c as _c } from "react/compiler-runtime";
import type { ButtonProps, InputProps } from '@chakra-ui/react';
import { Button, Clipboard as ChakraClipboard, IconButton, Input } from '@chakra-ui/react';
import * as React from 'react';
import { LuCheck, LuClipboard, LuLink } from 'react-icons/lu';
const ClipboardIcon = React.forwardRef<HTMLDivElement, ChakraClipboard.IndicatorProps>(function ClipboardIcon(props, ref) {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <LuCheck />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <LuClipboard />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props || $[3] !== ref) {
    t2 = <ChakraClipboard.Indicator copied={t0} {...props} ref={ref}>{t1}</ChakraClipboard.Indicator>;
    $[2] = props;
    $[3] = ref;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
});
const ClipboardCopyText = React.forwardRef<HTMLDivElement, ChakraClipboard.IndicatorProps>(function ClipboardCopyText(props, ref) {
  const $ = _c(3);
  let t0;
  if ($[0] !== props || $[1] !== ref) {
    t0 = <ChakraClipboard.Indicator copied="Copied" {...props} ref={ref}>Copy</ChakraClipboard.Indicator>;
    $[0] = props;
    $[1] = ref;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
});
export const ClipboardLabel = React.forwardRef<HTMLLabelElement, ChakraClipboard.LabelProps>(function ClipboardLabel(props, ref) {
  const $ = _c(3);
  let t0;
  if ($[0] !== props || $[1] !== ref) {
    t0 = <ChakraClipboard.Label display="inline-block" fontWeight="medium" marginBottom="1" textStyle="sm" {...props} ref={ref} />;
    $[0] = props;
    $[1] = ref;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
});
export const ClipboardButton = React.forwardRef<HTMLButtonElement, ButtonProps>(function ClipboardButton(props, ref) {
  const $ = _c(5);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ClipboardIcon />;
    t1 = <ClipboardCopyText />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props || $[3] !== ref) {
    t2 = <ChakraClipboard.Trigger asChild={true}><Button ref={ref} size="sm" variant="surface" {...props}>{t0}{t1}</Button></ChakraClipboard.Trigger>;
    $[2] = props;
    $[3] = ref;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
});
export const ClipboardLink = React.forwardRef<HTMLButtonElement, ButtonProps>(function ClipboardLink(props, ref) {
  const $ = _c(5);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <LuLink />;
    t1 = <ClipboardCopyText />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props || $[3] !== ref) {
    t2 = <ChakraClipboard.Trigger asChild={true}><Button ref={ref} unstyled={true} alignItems="center" display="inline-flex" gap="2" size="xs" variant="plain" {...props}>{t0}{t1}</Button></ChakraClipboard.Trigger>;
    $[2] = props;
    $[3] = ref;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
});
export const ClipboardIconButton = React.forwardRef<HTMLButtonElement, ButtonProps>(function ClipboardIconButton(props, ref) {
  const $ = _c(5);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ClipboardIcon />;
    t1 = <ClipboardCopyText srOnly={true} />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props || $[3] !== ref) {
    t2 = <ChakraClipboard.Trigger asChild={true}><IconButton ref={ref} size="xs" variant="subtle" {...props}>{t0}{t1}</IconButton></ChakraClipboard.Trigger>;
    $[2] = props;
    $[3] = ref;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
});
export const ClipboardInput = React.forwardRef<HTMLInputElement, InputProps>(function ClipboardInputElement(props, ref) {
  const $ = _c(3);
  let t0;
  if ($[0] !== props || $[1] !== ref) {
    t0 = <ChakraClipboard.Input asChild={true}><Input ref={ref} {...props} /></ChakraClipboard.Input>;
    $[0] = props;
    $[1] = ref;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
});
export const ClipboardRoot = ChakraClipboard.Root;